







import Vue from 'vue';
import moment from 'moment';
import QueueForm from '@/components/Forms/QueueForm.vue';

export default Vue.extend({
  name: 'webview',
  components: {
    QueueForm,
  },
  computed: {
    // queryParameters() {
    //   return this.$store.getters['appData/QUERY_PARAMETERS'];
    // },
  },
  // mounted: function() {
  //    console.log('QUERYPARAMS', this.queryParameters);
  // },
});
